<a id="filter-link" class="filter-link" (click)="toggleRadarChartSidebar()" [ngClass]="{ active: globalData.applicationState.radarChartSidebarOpen }">
  <mat-icon svgIcon="graph-filter"></mat-icon>
</a>
